import React from 'react';
import { ReferrerBadgeLevel } from '../types/RatingTypes';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

interface ReferrerBadgeProps {
  badge: ReferrerBadgeLevel;
  size?: 'small' | 'medium';
}

const badgeConfig: Record<ReferrerBadgeLevel, { label: string; color: string; bg: string }> = {
  new: { label: 'New Referrer', color: '#6b7280', bg: '#f3f4f6' },
  active: { label: 'Active Referrer', color: '#2563eb', bg: '#dbeafe' },
  top: { label: 'Top Referrer', color: '#d97706', bg: '#fef3c7' },
  elite: { label: 'Elite Referrer', color: '#7c3aed', bg: '#ede9fe' },
};

const ReferrerBadge: React.FC<ReferrerBadgeProps> = ({ badge, size = 'medium' }) => {
  const config = badgeConfig[badge];
  const iconSize = size === 'small' ? 14 : 16;

  return (
    <span
      className={`referrer-badge referrer-badge-${size}`}
      style={{ color: config.color, backgroundColor: config.bg }}
    >
      {badge === 'elite' ? (
        <EmojiEventsOutlinedIcon sx={{ fontSize: iconSize }} />
      ) : badge === 'top' ? (
        <StarIcon sx={{ fontSize: iconSize }} />
      ) : (
        <StarOutlineIcon sx={{ fontSize: iconSize }} />
      )}
      {config.label}
    </span>
  );
};

export default ReferrerBadge;
